import React, { FC, useState } from 'react'
import { isMobile } from 'react-device-detect'

import { WizzardPageBox, WizzardPhotoInfoRow } from '../style/UserWIzzardStyle'

import CheckIcon from '../../../assets/REDESIGN_Assets/UserWizzard/check_arrow.png'

import GenericInput from '../../../GenericComponents/GenericInput'
import GenericIcon from '../../../GenericComponents/GenericIcon'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'

interface WizzardPage4Interface {}

const WizzardPage4: FC<WizzardPage4Interface> = ({}) => {
  return (
    <WizzardPageBox className="wizzard-photo-info">
      <WizzardPhotoInfoRow>
        <GenericIcon
          margin={isMobile ? '0 3% 0 0' : '0 6% 0 0'}
          width={isMobile ? '3vw' : '1.1vw'}
          height={isMobile ? '2.5vh' : '1.2vh'}
          src={CheckIcon}
        />
        <GenericTextSpan tAlign={'left'} fSize={'0.85rem'}>
          Żeby zrobić zdjęcie, poproś kogoś z domowników o pomoc lub stań przed
          lustrem.
        </GenericTextSpan>
      </WizzardPhotoInfoRow>
      <WizzardPhotoInfoRow>
        <GenericIcon
          margin={isMobile ? '0 3% 0 0' : '0 6% 0 0'}
          width={isMobile ? '3vw' : '1.1vw'}
          height={isMobile ? '2.5vh' : '1.2vh'}
          src={CheckIcon}
        />
        <GenericTextSpan tAlign={'left'} fSize={'0.85rem'}>
          Ustaw się tak, żeby Twoje ciało pokryło się z zarysem postaci którą
          widzisz na ekranie.
        </GenericTextSpan>
      </WizzardPhotoInfoRow>
      <WizzardPhotoInfoRow>
        <GenericIcon
          margin={isMobile ? '0 3% 0 0' : '0 6% 0 0'}
          width={isMobile ? '3vw' : '1.1vw'}
          height={isMobile ? '2.5vh' : '1.2vh'}
          src={CheckIcon}
        />
        <GenericTextSpan tAlign={'left'} fSize={'0.85rem'}>
          Staraj się stać prosto - proste plecy, ale bez napinania brzucha.
        </GenericTextSpan>
      </WizzardPhotoInfoRow>

      <GenericTextSpan tAlign={'left'} fSize={'0.9rem'} margin={'3% 0 5% 0% '}>
        Ważne! Jeśli któreś ze zdjęć jest nieostre lub niepoprawnie zrobione
        usuń je i powtórz cały proces. Poprawność wykonania zdjęć ma ogromny
        wpływ na ich późniejsze zestawienie.
      </GenericTextSpan>
    </WizzardPageBox>
  )
}

export default WizzardPage4
